<template>
  <PublicPopup
    ref="PopupRef"
    :padding="15"
    :closeable="false"
    close-type="manual"
    @close="handleEmitClose"
    @manual-close="handleEmitManualClose"
  >
    <template #content>
      <div class="registr-greetings-popup">
        <div class="header-container chxy-column-c-c">
          <van-icon name="cross" class="close-icon" @click="manualClose" />
          <div class="icon-checked-box chxy-row-c-c">
            <van-icon name="passed" class="icon" />
          </div>
          <div class="icon-cheers-box chxy-row-bt">
            <img
              class="icon left"
              :src="getImageUrlWithCDN_TEST('/baixe/icon_cheers.png', 'local')"
            />
            <span class="content">{{ $t('DownloadPopup-RegistrGreetingsPopup.congrats') }}</span>
            <img
              class="icon right"
              :src="getImageUrlWithCDN_TEST('/baixe/icon_cheers.png', 'local')"
            />
          </div>
          <span class="greetings-content">
            <p>
              {{ $t('DownloadPopup-RegistrGreetingsPopup.bonusLine1Prefix') }}
              <span style="color: #e03e2d">
                {{ $t('DownloadPopup-RegistrGreetingsPopup.bonusLine1Highlight') }}
              </span>
              {{ $t('DownloadPopup-RegistrGreetingsPopup.bonusLine1Suffix') }}
            </p>
            <p>
              {{ $t('DownloadPopup-RegistrGreetingsPopup.bonusLine2Prefix') }}
              <span style="color: #e03e2d">
                {{ $t('DownloadPopup-RegistrGreetingsPopup.bonusLine2Highlight') }}
              </span>
              {{ $t('DownloadPopup-RegistrGreetingsPopup.bonusLine2Suffix') }}
            </p>
          </span>
        </div>

        <!-- 首存优惠入口卡片 -->
        <div class="deposit-offer-card">
          <img
            class="offer-icon"
            :src="getImageUrlWithCDN_TEST('/activity/maxim_icon.png', 'local')"
            alt=""
          />
          <div class="offer-info">
            <div class="offer-title">
              {{ $t('DownloadPopup-RegistrGreetingsPopup.firstDepositTitle') }}
            </div>
            <div class="offer-timer">
              <div class="lt-icon-container">
                <img
                  class="lt-icon"
                  :src="getImageUrlWithCDN_TEST('/deposito/lt.png', 'local')"
                  alt=""
                />
                <span class="lt-text">{{ $t('DownloadPopup-RegistrGreetingsPopup.lt') }}</span>
              </div>
              <van-count-down :time="offerCountDown" format="HH:mm:ss" />
            </div>
          </div>
          <div class="offer-right">
            <div class="offer-amount-box">
              <span class="maximo">{{ $t('DownloadPopup-RegistrGreetingsPopup.maximo') }}</span>
              <div class="amount-row">
                <img
                  class="coin-icon"
                  :src="getImageUrlWithCDN_TEST('/activity/money.png', 'local')"
                  alt=""
                />
                <span class="amount">3.777,00</span>
              </div>
            </div>
            <van-icon name="arrow" class="arrow-icon" @click="handleGoActiInfoThree" />
          </div>
        </div>

        <InstallButtonsReg
          ref="InstallButtonsRegRef"
          @download="handleDownload"
          @deposite="handleDeposite"
        />
      </div>
    </template>
  </PublicPopup>

  <DownloadGuidePopup ref="DownloadGuidePopupRef" />
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
const PopupRef = ref(null)
const InstallButtonsRegRef = ref(null)
// 倒计时占位：约 18 小时 56 分（对齐 UI 示意）
const offerCountDown = ref((18 * 60 + 56) * 60 * 1000)

// 下载pwa的前置弹窗
const open = () => {
  nextTick(() => {
    PopupRef.value.open()

    const installPrompt = window.deferredPrompt
    if (installPrompt) {
      nextTick(() => {
        InstallButtonsRegRef.value.init(installPrompt)
      })
    }
  })
}
const close = () => {
  PopupRef.value.close()
}
const handleEmitClose = () => {
  emit('close')
}

const manualClose = () => {
  PopupRef.value.manualClose()
}
const handleEmitManualClose = () => {
  emit('manualClose')
}

/**
 * 下载引导弹窗
 */
const DownloadGuidePopupRef = ref(null)
const handleDownloadGuidePopupOpen = () => {
  nextTick(() => {
    DownloadGuidePopupRef.value.open()
  })
}

const handleDownload = (isIos) => {
  emit('download')
  manualClose()
}
const handleDeposite = () => {
  emit('deposite')
  close()
}

const handleGoActiInfoThree = () => {
  close()
  router.push({ name: 'acti-info-three' })
}

const emit = defineEmits(['close', 'manualClose', 'download', 'deposite'])

defineExpose({ open })
</script>

<style scoped lang="scss">
.registr-greetings-popup {
  .header-container {
    position: relative;
    margin-bottom: 12px;
    gap: 10px;

    .close-icon {
      position: absolute;
      top: -6px;
      right: -6px;
      z-index: 1;
      font-size: 18px;
      color: #666;
      cursor: pointer;
    }

    .icon-checked-box {
      .icon {
        font-size: 34px;
        color: var(--reg-greetings-popup-header-checked-icon);
        -webkit-text-stroke: 1px currentColor;
        paint-order: stroke fill;
      }
    }

    .icon-cheers-box {
      width: 100%;

      .content {
        width: 75%;
        font-size: 20px;
        font-weight: 400;
        text-align: center;
        line-height: 1.2;
        color: var(--reg-greetings-popup-header-title);
      }
      .icon {
        width: 24px;

        &.left {
          transform: scaleX(-1);
        }
      }
    }

    .greetings-content {
      margin-bottom: 0;
      font-size: 12px;
      font-family: 'Segoe UI';
      text-align: center;
      color: var(--reg-greetings-popup-header-content);
      line-height: 1.8;
    }
  }

  .deposit-offer-card {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    height: 54px;
    min-height: 54px;
    margin-bottom: 35px;
    padding: 8px 8px 8px 10px;
    box-sizing: border-box;
    background: #f6eddd;
    border-radius: 10px;
    border-left: 5px solid #ffa008;
    cursor: pointer;

    .offer-icon {
      flex-shrink: 0;
      width: 34px;
      height: 34px;
      object-fit: contain;
    }

    .offer-info {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 4px;

      .offer-title {
        font-size: 12px;
        font-weight: 500;
        color: #333;
        line-height: 1.2;
        white-space: nowrap;
      }

      .offer-timer {
        display: inline-flex;
        align-items: center;
        align-self: flex-start;
        height: 16px;
        padding-right: 4px;
        border: 1px solid #e03e2d;
        border-radius: 2px;
        --van-count-down-font-size: 8px;
        --van-count-down-text-color: #e03e2d;
        --van-count-down-line-height: 14px;

        .lt-icon-container {
          position: relative;
          margin-left: -1px;
          margin-right: 2px;

          .lt-icon {
            width: 22px;
            height: 14px;
            display: block;
          }

          .lt-text {
            position: absolute;
            top: 50%;
            right: 4px;
            transform: translateY(-50%);
            color: #fff;
            font-size: 8px;
            font-weight: 600;
            line-height: 1;
          }
        }
      }
    }

    .offer-right {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      gap: 4px;

      .offer-amount-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;

        .maximo {
          font-size: 12px;
          color: #000;
          line-height: 1;
        }

        .amount-row {
          display: flex;
          align-items: center;
          gap: 2px;

          .coin-icon {
            width: 12px;
            height: 12px;
          }

          .amount {
            font-size: 12px;
            font-weight: 700;
            color: #ff8a00;
            line-height: 1;
          }
        }
      }

      .arrow-icon {
        font-size: 14px;
        color: #ccc;
      }
    }
  }
}
</style>
